import { render, staticRenderFns } from "./contest-detail.vue?vue&type=template&id=09374c18&scoped=true"
import script from "./contest-detail.vue?vue&type=script&lang=js"
export * from "./contest-detail.vue?vue&type=script&lang=js"
import style0 from "./contest-detail.vue?vue&type=style&index=0&id=09374c18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09374c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09374c18')) {
      api.createRecord('09374c18', component.options)
    } else {
      api.reload('09374c18', component.options)
    }
    module.hot.accept("./contest-detail.vue?vue&type=template&id=09374c18&scoped=true", function () {
      api.rerender('09374c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/contest-detail.vue"
export default component.exports